var map = {
	"./academic.svg": "./src/assets/images/fast-tracking/validations/academic.svg",
	"./antecedents.svg": "./src/assets/images/fast-tracking/validations/antecedents.svg",
	"./datacredito.svg": "./src/assets/images/fast-tracking/validations/datacredito.svg",
	"./laboral.svg": "./src/assets/images/fast-tracking/validations/laboral.svg",
	"./on-boarding.svg": "./src/assets/images/fast-tracking/validations/on-boarding.svg",
	"./personal.svg": "./src/assets/images/fast-tracking/validations/personal.svg",
	"./polygraph.svg": "./src/assets/images/fast-tracking/validations/polygraph.svg",
	"./psychotechnical.svg": "./src/assets/images/fast-tracking/validations/psychotechnical.svg",
	"./remote-work-visit.svg": "./src/assets/images/fast-tracking/validations/remote-work-visit.svg",
	"./visit.svg": "./src/assets/images/fast-tracking/validations/visit.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/fast-tracking/validations sync recursive ^\\.\\/.*\\.svg$";